import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text, View } from '@olxbr/design-system'
import HelpOption from '../../molecules/HelpOption'
import lockSvgPath from '../../../assets/icons/lock'
import logoutSvgPath from '../../../assets/icons/logout'
import userSvgPath from '../../../assets/icons/user'
import Lurker from '../../../util/lurker'
import { Link } from '@olxbr/ds-web'
import { User, Lock, LogOut, HelpCircle } from '@olxbr/ds-icons'
import { isLoginScrollEnabled } from '../../../util/experiments'
import { faleConosco } from '../../../config/staticUrl'

const lurker = new Lurker('help_modal')

const Title = styled(Text)`
  padding-bottom: 8px;
`

const Header = styled(View)`
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;
`

const Content = styled(View)`
  display: flex;
  flex-direction: column;
`

class HelpContent extends React.Component {
  onOptionClick = (onClick, lurkerEvent) => () => {
    if (onClick) {
      lurker.clickEvt(lurkerEvent)
      if (typeof onClick === 'function') {
        onClick()
      } else if (typeof onClick === 'string') {
        window.location.href = onClick
      }
    }

    if (this.props.onOptionClick) {
      this.props.onOptionClick()
    }
  }

  handleBackClick = () => {
    const { onBackClick } = this.props

    lurker.clickEvt('back')
    if (typeof onBackClick === 'function') {
      onBackClick()
    }
  }

  render() {
    const {
      abTests,
      onForgotPasswordLinkClick,
      onReactivationLinkClick,
      onMagicLinkClick,
      modalMode = false,
    } = this.props

    const experimentOn = isLoginScrollEnabled(abTests)

    const reactivationIcon = experimentOn
      ? { icon: <User width={16} height={16} /> }
      : { svgPath: userSvgPath }

    const forgotPasswordIcon = experimentOn
      ? { icon: <Lock width={16} height={16} /> }
      : { svgPath: lockSvgPath }

    const magicLinkIcon = experimentOn
      ? { icon: <LogOut width={16} height={16} /> }
      : { svgPath: logoutSvgPath }

    return (
      <View>
        {experimentOn ? (
          <span className="typo-title-medium font-semibold mb-3">Como podemos ajudar?</span>
        ) : (
          <Header>
            <Title size="title2" fontWeight={600}>
              Como podemos ajudar?
            </Title>
            <Text size="caption" color="grayscale.darker">
              Enviaremos um e-mail para ajudar você a acessar sua conta!
            </Text>
          </Header>
        )}
        <Content>
          {onReactivationLinkClick && (
            <HelpOption
              text="Quero reativar minha conta"
              {...reactivationIcon}
              compact={experimentOn}
              onClick={this.onOptionClick(onReactivationLinkClick, 'account_reactivation')}
              last={!onForgotPasswordLinkClick && !onMagicLinkClick}
            />
          )}
          {onForgotPasswordLinkClick && (
            <HelpOption
              text="Esqueci a minha senha"
              {...forgotPasswordIcon}
              compact={experimentOn}
              onClick={this.onOptionClick(onForgotPasswordLinkClick, 'forgot_password')}
              last={!onMagicLinkClick}
            />
          )}
          {onMagicLinkClick && (
            <HelpOption
              text="Entrar sem senha"
              {...magicLinkIcon}
              compact={experimentOn}
              onClick={this.onOptionClick(onMagicLinkClick, 'passwordless_login_button')}
              last={!experimentOn}
            />
          )}
          {experimentOn && (
            <HelpOption
              text="Preciso de mais ajuda"
              icon={<HelpCircle size={16} />}
              compact
              onClick={this.onOptionClick(faleConosco, 'need_more_help')}
              last
            />
          )}
        </Content>
        {modalMode && (
          <div className="flex justify-start mt-2">
            <Link
              size="medium"
              onClick={() => {
                this.handleBackClick()
              }}
            >
              Voltar
            </Link>
          </div>
        )}
      </View>
    )
  }
}

HelpContent.propTypes = {
  abTests: PropTypes.string,
  onForgotPasswordLinkClick: PropTypes.func,
  onReactivationLinkClick: PropTypes.func,
  onMagicLinkClick: PropTypes.func,
  onOptionClick: PropTypes.func,
  onBackClick: PropTypes.func,
  modalMode: PropTypes.bool,
}

export default HelpContent
